// App.tsx
import React from "react";
import { ThemeProvider } from "./components/ThemeContext";
import AppContent from "./AppContent";

// CssBaseline lives in AppContent, not here: it needs the mode-aware MUI theme, which is only
// created down there. Rendered at this level it would paint <body> from the default (light)
// theme.
const App: React.FC = () => {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
};

export default App;